import { useTranslation } from 'react-i18next';

const KEY = {
  DEL: 'Del',
  BACKSPACE: 'Backspace',
  ESC: 'Esc',
};

const toolItemClass =
  'mr-3 mb-3 p-2 h-10 cursor-pointer flex flex-col justify-center items-center bg-secondary-dark rounded text-white text-base';

const ScalpelToolbar = ({ handleActionScalpel }) => {
  const { t } = useTranslation('ViewerTool');

  return (
    <div
      className="cutting-toolbar flex"
      style={
        window.innerWidth >= 1100
          ? {
              position: 'absolute',
              bottom: 0,
              left: 10,
            }
          : {
              position: 'absolute',
              top: '50%',
              left: 10,
              transform: 'translateY(-50%)',
              flexDirection: 'column',
            }
      }
    >
      <div onClick={() => handleActionScalpel(KEY.DEL)} className={toolItemClass}>
        <span>{t('Cut inside')}</span>
        <span>{t('Del')}</span>
      </div>
      <div onClick={() => handleActionScalpel(KEY.BACKSPACE)} className={toolItemClass}>
        <span>{t('Cut outside')}</span>
        <span>{t('Backspace')}</span>
      </div>
      <div onClick={() => handleActionScalpel(KEY.ESC)} className={toolItemClass}>
        <span>{t('Clear area')}</span>
        <span>{t('Esc')}</span>
      </div>
    </div>
  );
};

export default ScalpelToolbar;
